const ISPM_CONSTANTS = {
  SAVI_INPUT_PLACEHOLDER: 'Type a message and press Enter...',
  IFRAME_URL: 'https://superset-intelligence-dev.saviyntcloud.com/',
  ECM_URL: window.location.origin,
  ISPM_SUGGESTIONS_URL: '/ECMv6/api/ispm/chat/suggestions',
  ISPM_CHAT_ASK_URL: '/ECMv6/api/ispm/chat/ask',
};

export default ISPM_CONSTANTS;
